// Dependencies
import React, { Component } from 'react';

// Multi lang
import { withTranslation } from 'react-multi-lang';

// Styling
import './quote-payment-plan-creation.scss';

// Utils
import { QUOTE_PAYMENT_PLAN_MONTH_PERIODS, QUOTE_PAYMENT_START_MONTH } from '../../../common/lists/quote';

// Primereact imports
import { Toast } from 'primereact/toast';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';

// Services
import QuoteService from '../../../redux/services/quote';


class QuotePaymentPlanCreationComponent extends Component {

   constructor(props) {
        super(props);
        this._toast = React.createRef();
        this.state = {
            startMonth: { name: 'Mês atual', code: 1 },
            quotePaymentPlanParts: [],
            numMonthList: [],
            totalAmount: 0,
            validationError: false,
            exceedMonths: 0
        };
    }
    
    componentDidMount() {
        var delayMonths = this.props.quotePaymentPlan.delayMonths;      

        if(new Date().getDate() >= 15) {
            delayMonths++;
        }

        var numParcels = Math.floor(delayMonths / 6);
        var extraMonths = (delayMonths % 6) + (numParcels - 1);     

        if(extraMonths >= 6) {
            
            this.setState({
                exceedMonths: 1
            });

            numParcels++;
            extraMonths -= 5; // it is 5 since we are adding one parcel month
        }

        this.setState({
            totalAmount: ((numParcels * 6) + extraMonths) * 12
        });
       
       var quotePaymentPlanParts = [];
       var month = (new Date().getMonth() + 1);
       var year = new Date().getFullYear();

       for (let i = 1; i <= numParcels; i++) {
            quotePaymentPlanParts.push({
                parcelId: i,
                numMonths: i == numParcels ?  { name: (6 + extraMonths).toString(), code: (6 + extraMonths) } : { name: '6', code: 6 },
                month: this.getFormattedMonth(month) + " " + year,
                paymentMonth: month + "-" + year,
                monthPeriod: { name: 'Dia 1 a 15', code: 1 },
                amount: null
            });

            if(month === 12) {
                month = 1;
                year++;
            }
            else {
                month++;
            }
       }

       var numMonths  = [];

       for (let j = 6; j <= this.props.quotePaymentPlan.delayMonths; j++) {
            numMonths.push({ name: j.toString(), code: j });
       }

       this.setState({
            numMonthList: numMonths,
       });

       this.calculatePaymentPlanAmountDetails(quotePaymentPlanParts);
    }

    calculatePaymentPlanAmountDetails(quotePaymentPlanParts) {
        let planParts = [];
        for (let i = 0; i < quotePaymentPlanParts.length; i++) {
            planParts.push(quotePaymentPlanParts[i].numMonths.code);
        }

        QuoteService.calculatePaymentPlanDetails({
            quotePaymentPlanRef: this.props.quotePaymentPlan.quotePaymentPlanRef,
            planParts: planParts
        }).then((response) => {
            for (let j = 0; j < quotePaymentPlanParts.length; j++) {
                var amount = Number(response.planPaymentParts[j].fee);

                for (let k = 0; k < response.planPaymentParts[j].quotes.length; k++) {
                    amount += Number(response.planPaymentParts[j].quotes[k].price);
                }

                quotePaymentPlanParts[j].amount = (Math.round(amount * 100) / 100);                
            }
            
            this.setState({
                quotePaymentPlanParts: quotePaymentPlanParts
            });
        })
        .catch(error => {
            this._toast.current.show({ severity: 'error', detail: this.props.t("quotes.messages.payment-plan-calculation-error"), life: 3000 });
        });
    }

    getFormattedAmountValue(amount) {

        if(amount.toString().includes(".")) {
            let amountParts = amount.toString().split(".");

            if(amountParts[1].length === 1) {
                return amount + "0 €";
            }
            else {
                return amount + " €";
            }     
        }
        else {
            return amount + ".00 €";
        }       

        return "";
    }

    getFormattedMonth(month) {
        var formattedMonth = "";

        switch(month) {
            case 1: formattedMonth = this.props.t("general.months.jan"); break;
            case 2: formattedMonth = this.props.t("general.months.fev"); break;
            case 3: formattedMonth = this.props.t("general.months.mar"); break;
            case 4: formattedMonth = this.props.t("general.months.abr"); break;
            case 5: formattedMonth = this.props.t("general.months.mai"); break;
            case 6: formattedMonth = this.props.t("general.months.jun"); break;
            case 7: formattedMonth = this.props.t("general.months.jul"); break;
            case 8: formattedMonth = this.props.t("general.months.ago"); break;
            case 9: formattedMonth = this.props.t("general.months.set"); break;
            case 10: formattedMonth = this.props.t("general.months.out"); break;
            case 11: formattedMonth = this.props.t("general.months.nov"); break;
            case 12: formattedMonth = this.props.t("general.months.dez"); break;
        }

        return formattedMonth;
    }

    addParcel() {
        var quotePaymentPlanParts = [];
        let month = this.state.startMonth.code === 1 ? (new Date().getMonth() + 1) : (new Date().getMonth() + 1) === 12 ? 1 : (new Date().getMonth() + 2);
        let year = this.state.startMonth.code === 1 ? new Date().getFullYear() : (new Date().getMonth() + 1) === 12 ? new Date().getFullYear() + 1 : new Date().getFullYear();

        for (let i = 0; i < this.state.quotePaymentPlanParts.length; i++) {
            quotePaymentPlanParts.push({
                parcelId: this.state.quotePaymentPlanParts[i].parcelId,
                numMonths: this.state.quotePaymentPlanParts[i].numMonths,
                month: this.getFormattedMonth(month) + " " + year,
                paymentMonth: month + "-" + year,
                monthPeriod: this.state.quotePaymentPlanParts[i].monthPeriod
            });

            if(month === 12) {
                month = 1;
                year++;
            }
            else {
                month++;
            }
        }

        quotePaymentPlanParts.push({
            parcelId: quotePaymentPlanParts.length + 1,
            numMonths: { name: '6', code: 6 },
            month: this.getFormattedMonth(month) + " " + year,
            paymentMonth: month + "-" + year,
            monthPeriod: { name: 'Dia 1 a 15', code: 1 }
        });

        this.calculatePaymentPlanAmountDetails(quotePaymentPlanParts);
    }

    removeParcel(parcel) {
        var quotePaymentPlanParts = [];
        
        let month = this.state.startMonth.code === 1 ? (new Date().getMonth() + 1) : (new Date().getMonth() + 1) === 12 ? 1 : (new Date().getMonth() + 2);
        let year = this.state.startMonth.code === 1 ? new Date().getFullYear() : (new Date().getMonth() + 1) === 12 ? new Date().getFullYear() + 1 : new Date().getFullYear();

        for (let i = 0; i < this.state.quotePaymentPlanParts.length; i++) {
            if(this.state.quotePaymentPlanParts[i].parcelId !== parcel) {
                quotePaymentPlanParts.push({
                    parcelId: quotePaymentPlanParts.length + 1,
                    numMonths: this.state.quotePaymentPlanParts[i].numMonths,   
                    month: this.getFormattedMonth(month) + " " + year,
                    paymentMonth: month + "-" + year,
                    monthPeriod: this.state.quotePaymentPlanParts[i].monthPeriod
                });

                if(month === 12) {
                    month = 1;
                    year++;
                }
                else {
                    month++;
                }
            }
        }

        this.calculatePaymentPlanAmountDetails(quotePaymentPlanParts);
    }

    updateStartMonth(startMonth) {
        this.setState({
            startMonth: startMonth
        });
        let month = startMonth.code === 1 ? (new Date().getMonth() + 1) : (new Date().getMonth() + 1) === 12 ? 1 : (new Date().getMonth() + 2);
        let year = startMonth.code === 1 ? new Date().getFullYear() : (new Date().getMonth() + 1) === 12 ? new Date().getFullYear() + 1 : new Date().getFullYear();

        var quotePaymentPlanParts = [];

        for (let i = 0; i < this.state.quotePaymentPlanParts.length; i++) {            
            if(startMonth.code === 1) {
                quotePaymentPlanParts.push({
                    parcelId: this.state.quotePaymentPlanParts[i].parcelId,
                    numMonths: ((i+1) !== this.state.quotePaymentPlanParts.length) ? this.state.quotePaymentPlanParts[i].numMonths : { code: (this.state.quotePaymentPlanParts[i].numMonths.code - 1), name: (this.state.quotePaymentPlanParts[i].numMonths.code - 1).toString() },
                    month: this.getFormattedMonth(month) + " " + year,
                    paymentMonth: month + "-" + year,
                    monthPeriod: this.state.quotePaymentPlanParts[i].monthPeriod
                });
            }
            else {
                quotePaymentPlanParts.push({
                    parcelId: this.state.quotePaymentPlanParts[i].parcelId,
                    numMonths: ((i+1) !== this.state.quotePaymentPlanParts.length) ? this.state.quotePaymentPlanParts[i].numMonths : { code: (this.state.quotePaymentPlanParts[i].numMonths.code + 1), name: (this.state.quotePaymentPlanParts[i].numMonths.code + 1).toString() },
                    month: this.getFormattedMonth(month) + " " + year,
                    paymentMonth: month + "-" + year,
                    monthPeriod: this.state.quotePaymentPlanParts[i].monthPeriod
                });
            }
            
            if(month === 12) {
                month = 1;
                year++;
            }
            else {
                month++;
            }
        }

        // Recalculate total amount
        var delayMonths = this.props.quotePaymentPlan.delayMonths;

        if(new Date().getDate() < 15) {
            delayMonths++;
        }
        var numParcels = Math.floor(delayMonths / 6);
        var extraMonths = (delayMonths % 6) + (numParcels - 1);  

        if(startMonth.code === 1) {
            this.setState({
                totalAmount: ((numParcels * 6) + extraMonths) * 12
            });
        }
        else {
            this.setState({
                totalAmount: ((numParcels * 6) + extraMonths + 1) * 12
            });
        }
        
        this.calculatePaymentPlanAmountDetails(quotePaymentPlanParts);
    }

    updateMonthPeriod(parcel, monthPeriod) {
        var quotePaymentPlanParts = [];

        for (let i = 0; i < this.state.quotePaymentPlanParts.length; i++) {
            quotePaymentPlanParts.push({
                parcelId: this.state.quotePaymentPlanParts[i].parcelId,
                numMonths: this.state.quotePaymentPlanParts[i].numMonths,
                month: this.state.quotePaymentPlanParts[i].month,
                paymentMonth:  this.state.quotePaymentPlanParts[i].paymentMonth,
                monthPeriod: this.state.quotePaymentPlanParts[i].parcelId === parcel ? monthPeriod : this.state.quotePaymentPlanParts[i].monthPeriod
            });
        }

        this.calculatePaymentPlanAmountDetails(quotePaymentPlanParts);
    }

    updateNumMonth(parcel, numMonth) {
        var quotePaymentPlanParts = [];

        for (let i = 0; i < this.state.quotePaymentPlanParts.length; i++) {
            quotePaymentPlanParts.push({
                parcelId: this.state.quotePaymentPlanParts[i].parcelId,
                numMonths: this.state.quotePaymentPlanParts[i].parcelId === parcel ? numMonth : this.state.quotePaymentPlanParts[i].numMonths,
                month: this.state.quotePaymentPlanParts[i].month,
                paymentMonth:  this.state.quotePaymentPlanParts[i].paymentMonth,
                monthPeriod: this.state.quotePaymentPlanParts[i].monthPeriod
            });
        }

        this.calculatePaymentPlanAmountDetails(quotePaymentPlanParts);
    }

    monthPeriodBodyTemplate(rowData) {
        return <Dropdown className="w-full mgt-7" value={rowData.monthPeriod} options={QUOTE_PAYMENT_PLAN_MONTH_PERIODS} optionLabel="name" onChange={(evt) => this.updateMonthPeriod(rowData.parcelId, evt.value)}></Dropdown> 
    }

    numMonthBodyTemplate(rowData) {
        return <Dropdown className="w-full mgt-7" value={rowData.numMonths} options={this.state.numMonthList} optionLabel="name" onChange={(evt) => this.updateNumMonth(rowData.parcelId, evt.value)}></Dropdown> 
    }

    actionsBodyTemplate(rowData, collection) {
        return <div className='t-align-center'>
            <Button icon="pi pi-times-circle" size='small' severity="danger" tooltip={this.props.t("quotes.dialog.delete-payment-plan-part")} iconPos="center" onClick={() => this.removeParcel(rowData.parcelId)} />
        </div>;
    }

    submitPlan() {
        if(this.validatePlan()) {
            var planParts = [];

            let month = this.state.startMonth.code === 1 ? (new Date().getMonth() + 1) : (new Date().getMonth() + 1) === 12 ? 1 : (new Date().getMonth() + 2);
            let year = this.state.startMonth.code === 1 ? new Date().getFullYear() : (new Date().getMonth() + 1) === 12 ? new Date().getFullYear() + 1 : new Date().getFullYear();

            for (let i = 0; i < this.state.quotePaymentPlanParts.length; i++) {
                var paymentDateParts = this.state.quotePaymentPlanParts[i].paymentMonth.split("-");

                planParts.push({
                    numMonths: this.state.quotePaymentPlanParts[i].numMonths.code,
                    amount: this.state.quotePaymentPlanParts[i].amount,
                    paymentInInitialPartMonth: this.state.quotePaymentPlanParts[i].monthPeriod.code === 1,
                    expectedPaymentDate: new Date(Number(paymentDateParts[1]), Number(paymentDateParts[0] - 1), 1, 10, 0, 0, 0)
                });
            }

            QuoteService.activeQuotePaymentPlan({
                paymentPlanRef: this.props.quotePaymentPlan.quotePaymentPlanRef,
                parts: planParts
            }).then((response) => {
                this._toast.current.show({ severity: 'success', detail: this.props.t("quotes.messages.payment-plan-creation-success"), life: 3000 });
                setTimeout(() => {
                    this.props.submitCallback();
                    this.props.onClose();
                }, 1500);
            })
            .catch(error => {
                this._toast.current.show({ severity: 'error', detail: this.props.t("quotes.messages.payment-plan-creation-error"), life: 3000 });
            });
        }
    }

    validatePlan() {
        let validMonths = true;
        let validTotal = true;
        let validPeriod = true;
        let total = 0;

        for (let i = 0; i < this.state.quotePaymentPlanParts.length; i++) {
            if(this.state.quotePaymentPlanParts[i].numMonths === null) {
                validMonths = false;
                break;
            }
            else {
                total += Number(this.state.quotePaymentPlanParts[i].numMonths.code);
            }
        }      
        
        if(this.state.startMonth.code === 1) {
            /*if(new Date().getDate() < 15) {
                validTotal = total === (this.props.quotePaymentPlan.delayMonths + this.state.exceedMonths + this.state.quotePaymentPlanParts.length - 1);
            }
            else {
                validTotal = total === this.props.quotePaymentPlan.delayMonths + this.state.exceedMonths + (this.state.quotePaymentPlanParts.length );
            }*/
            validTotal = total === ((this.props.quotePaymentPlan.delayMonths - 1) + this.state.quotePaymentPlanParts.length);
        }
        else {
            validTotal = total === (this.props.quotePaymentPlan.delayMonths + this.state.quotePaymentPlanParts.length);
            /*if(new Date().getDate() < 15) {
                validTotal = total === (this.props.quotePaymentPlan.delayMonths + this.state.exceedMonths + this.state.quotePaymentPlanParts.length - 1) + 1;
            }
            else {
                validTotal = total === this.props.quotePaymentPlan.delayMonths + this.state.exceedMonths + (this.state.quotePaymentPlanParts.length) + 1;
            }*/
        }

        if(this.state.startMonth.code === 1) {
            validPeriod = !(this.state.quotePaymentPlanParts[0].monthPeriod.code === 1 && new Date().getDate() > 15);
        }

        this.setState({
            validationError: !validMonths || !validTotal || !validPeriod
        });       

        return validMonths && validTotal && validPeriod;
    }

    getPlanLastPaymentMonth() {
        if(this.state.quotePaymentPlanParts !== null && this.state.quotePaymentPlanParts.length > 0) {
            return this.state.quotePaymentPlanParts[this.state.quotePaymentPlanParts.length-1].month;
        }
        else {
            return "";
        }
    }

    render() {
      
        return (
            <div className="grid mgt-10">
                <div className="col-12 lg:col-12">
                    <p><b>{this.props.t("quotes.dialog.payment-plan-title")}</b></p>
                    <br/>
                    <p>{this.props.t("quotes.dialog.payment-plan-conditions-1")}</p>
                    <p><b>{this.props.t("quotes.dialog.payment-plan-conditions-2")}</b></p>
                    <li>{this.props.t("quotes.dialog.payment-plan-conditions-3")}</li>
                    <li>{this.props.t("quotes.dialog.payment-plan-conditions-4")}</li>
                    <li>{this.props.t("quotes.dialog.payment-plan-conditions-5")}</li>
                    <br/>
                    <p>{this.props.t("quotes.dialog.payment-plan-conditions-6")}</p>
                </div>
                <div className="col-12 mgt-10">
                    <label><b>{this.props.t("quotes.dialog.debt")}</b></label>
                </div>
                <div className="col-6 mgt-10">
                    <label><b>{this.props.t("quotes.dialog.debt-period")}</b> {this.getFormattedMonth(this.props.quotePaymentPlan.quoteStartMonth)} de {this.props.quotePaymentPlan.quoteStartYear} a {this.getFormattedMonth(this.props.quotePaymentPlan.quoteEndMonth)} de {this.props.quotePaymentPlan.quoteEndYear}</label>
                </div>
                <div className="col-6 mgt-10">
                    <label><b>{this.props.t("quotes.dialog.total")}</b> {this.getFormattedAmountValue(this.state.totalAmount)} + {this.props.t("quotes.dialog.fees")}</label>
                </div>
                <div className="col-12 mgt-10">
                    <label style={{color:"red"}}><b>{this.props.t("quotes.dialog.payment-plan-alert") + this.getPlanLastPaymentMonth() + "."}</b></label>
                </div>
                <div className="col-12 mgt-10">
                    <label><b>{this.props.t("quotes.dialog.payment-plan")}</b></label>
                </div>
                <div className='col-6 t-align-left'>
                    <span>{this.props.t("quotes.dialog.initial-month")}</span>
                    <Dropdown className="mgt-7 mgl-10" value={this.state.startMonth} options={QUOTE_PAYMENT_START_MONTH} optionLabel="name" onChange={(evt) => this.updateStartMonth(evt.value)}></Dropdown> 
                </div>
                <div className='col-6 t-align-right'>
                    <Button className='p-button-info' label={this.props.t("quotes.dialog.create-payment-plan-part")} onClick={() => this.addParcel()} />
                </div>
                <div className="col-12">
                    <DataTable value={this.state.quotePaymentPlanParts} className="p-datatable-gridlines" showGridlines rows={12} dataKey="parcelId" responsiveLayout="scroll" emptyMessage={this.props.t("quotes.messages.no-payment-plan-parts")}>
                        <Column field="parcelId" alignHeader="center" header={this.props.t("quotes.dialog.part")} style={{ minWidth: '20px', textAlign: "center" }}  />
                        <Column field="numMonths" alignHeader="center" header={this.props.t("quotes.dialog.num-months")} style={{ textAlign: "center" }} body={(data) => this.numMonthBodyTemplate(data)}/>
                        <Column field="month" alignHeader="center" header={this.props.t("quotes.dialog.month")} style={{ textAlign: "center" }} />
                        <Column field="monthPeriod" alignHeader="center" header={this.props.t("quotes.dialog.period")} style={{ textAlign: "center" }} body={(data) => this.monthPeriodBodyTemplate(data)}/>
                        <Column field="amount" alignHeader="center" header={this.props.t("quotes.dialog.amount")} style={{ textAlign: "center" }} body={(data) => this.getFormattedAmountValue(data.amount)} />
                        <Column field="ref" header="" body={(data) => this.actionsBodyTemplate(data)} style={{ minWidth: '30px' }} />
                    </DataTable>
                    { this.state.validationError ? <small className="p-error">{this.props.t("quotes.messages.invalid-payment-plan")}</small> : null  }
                </div>
                <div className='col-12 t-align-right'>
                    <Button className='p-button-success' label={this.props.t("quotes.dialog.submit")} onClick={() => this.submitPlan()} />
                </div>
                <Toast position='bottom-left' ref={this._toast} />
            </div>
        );
    }
}

export default withTranslation(QuotePaymentPlanCreationComponent);